import React from 'react';
import styled from "styled-components";
import ButtonBase from "@atoms/button.base";
import {useWindowSize} from "@helpers/windows.size";

function DropdownFooter({footer, setShow, type}) {
    const width = useWindowSize();

    if (typeof footer !== "undefined" && footer) {
        return (
            <Footer className="selection-dropdown-footer d-flex align-items-center justify-content-between mt-auto">
                <SelectButton onClick={() => setShow(false)} size={width > 992 ? 'sm' : ''} color="secondary" className="ml-0 ml-lg-8">انتخاب</SelectButton>
                <CancelButton onClick={() => setShow(false, false)} size={width > 992 ? 'sm' : ''} color="">بستن</CancelButton>
            </Footer>
        )
    } else {
        return null;
    }
}

export default React.memo(DropdownFooter);

// styles
export const SelectButton = styled(ButtonBase)`
   .modal-filter-body & {
        height: 48px !important;
   }
`;

const CancelButton = styled(ButtonBase)`
    opacity: 0;
    visibility: hidden;
    
    .modal-filter-body & {
        height: 48px !important;
    }
   
    @media only screen and (max-width: ${props => props.theme.screenSmMax}) {
        display: none;
    }
`;

const Footer = styled.div`
    padding: 16px 24px;
    border-radius: 0 0 16px 16px;
    background-color: ${props => props.theme.white};
    
    ${SelectButton},${CancelButton} {
        flex-grow: 1;
    }
    
    @media only screen and (max-width: ${props => props.theme.screenSmMax}) {
        ${SelectButton},${CancelButton} {
            width: 50%;
            padding: 0;
        }
    }
    @media only screen and (max-width: ${props => props.theme.screenXsMax}) {
        height: 80px;
        position: fixed;
        bottom: 0;
        right: 0;
        left: 0;
        padding: 0 24px;
        background-color: ${props => props.theme.white};
    }
`;